/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\CreateAccount\CreateAccount.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Monday August 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 26th October 2023 05:10:36
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useRef, useState, FormEvent } from "react";
import { Form, Button } from "react-bootstrap";
import { useLang } from "Router/LangueProvider";
import Styles from "Content/CreateAccount/CreateAccount.module.css";
import UserForm from "Content/Contact/UserForm/UserForm";
import CompanyForm2 from "Content/Contact/CompanyForm/CompanyForm";
import UserService from "Services/Users/UserService";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import BackArrow from "Content/BackArrow/BackArrow";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import { CompanyIntel } from "Types/company.type";
import { Address, AgreementRefType, UserCreationIntel, UserIntel } from "Types/user.type";
import AddressContact from "Content/Contact/AddressContact/AddressContact2";
import Agreement from "./Agreement/Agreement";

function CreateAccount() {
    const {translator} = useLang();
    const userIntelRef = useRef<UserIntel>({});
    const companyIntelRef = useRef<CompanyIntel>({});
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [isSendable, setIsSendable] = useState(false);
    const [openModal, setOpenModal] = useState<boolean>(false);

    const companyAddressRef = useRef<Address>({
        address: undefined,
        city: undefined,
        postalCode: undefined,
        state: undefined,
        country: undefined,
    });

    const agreementRef = useRef<AgreementRefType>({
        commercialCallTime: undefined,
        sellAgreementTime: undefined
    });

    const checkData = (data: {}) => {
        return Object.values(data).every(x => x);
    };

    const checkIsSendable = async () => {
        await new Promise(resolve => setTimeout(resolve, 100));
        if (checkData(userIntelRef.current) && checkData(companyAddressRef.current) && checkData(companyIntelRef.current) && agreementRef.current.sellAgreementTime)
            setIsSendable(true);
        else
            setIsSendable(false);
    };

    const HandleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setSpinner(true);
        let myIntels: UserCreationIntel = {
            LastName: (userIntelRef.current.lastName)!,
            FirstName: (userIntelRef.current.firstName)!,
            Email: userIntelRef.current.email!,
            Address: companyAddressRef.current?.address,
            City: companyAddressRef.current?.city,
            PostalCode: companyAddressRef.current?.postalCode!.padStart(5, '0'),
            State: companyAddressRef.current?.state,
            Country: companyAddressRef.current?.country,
            LanguageID: userIntelRef.current.language,
            Phone: userIntelRef.current.phone,
            CellPhone: userIntelRef.current.cellPhone,
            CommercialCallTime: agreementRef.current.commercialCallTime,
            SellAgreementTime: agreementRef.current.sellAgreementTime!,
            Company: {
                Name: companyIntelRef.current.Name,
                Siren: companyIntelRef.current.Siren,
                Country: companyAddressRef.current?.country,
                StandardPhoneNumber: userIntelRef.current.phone,
                Address: companyAddressRef.current?.address,
                City: companyAddressRef.current?.city,
                PostalCode: companyAddressRef.current?.postalCode!.padStart(5, '0'),
                State: companyAddressRef.current?.state
            }
        };

        UserService.addUser(myIntels).then(res => {
            if (res && res.status === 201)
                setIsOkay(true);
            else
                setIsOkay(false);

            setSpinner(false);
            setOpenModal(true);
        }).catch((reason: any) => {
            setIsOkay(false);
            setSpinner(false);
            setOpenModal(true);
        });
    };

    return(
        <div className={`${Styles.createAccountPage}`}>
            {
                spinner ?
                    <div className={`${Styles.spinnerHolder}`}>
                        <LoadingScreen />
                    </div>
                    :null
            }
            <img loading="lazy" className={`${Styles.backgroundImg}`} src="/contactLandScape.png" alt={translator.decode("image.background")} />
            <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                <div className={`${Styles.backArrowPos}`}>
                    <BackArrow />
                </div>
                <div className={`${Styles.forms}`}>
                    <UserForm ref={userIntelRef} onUpdate={checkIsSendable} />
                    <div className={`${Styles.leftColumn}`}>
                        <CompanyForm2 ref={companyIntelRef} onUpdate={checkIsSendable} />
                        <Agreement ref={agreementRef} onUpdate={checkIsSendable} />
                    </div>
                </div>
                <AddressContact address={{
                    houseNumber: "",
                    street: "",
                    postalCode: "",
                    city: "",
                    score: 0,
                    state: "",
                    country: ""
                    }} ref={companyAddressRef} onUpdate={checkIsSendable}
                />
                <div className={`${Styles.bottomOptions}`}>
                    <p><span className={`${Styles.asterisk}`}>*</span> {translator.decode("contact.mandatoryFields")}</p>
                    <Button disabled={!(isSendable)} type="submit">{translator.decode("dynamic.send")}</Button>
                </div>
            </Form>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} themeColor={""} />
        </div>
    );
}

export default CreateAccount;
